import "./Design.scss";
import site from "../assets/loggingSiteMediumRes.webp";
import teleopClose from "../assets/teleopClose.webp";
import SlotMachineRotator from '../components/SlotMachineRotator';

import React, { useRef, useEffect, useState } from 'react';


function Mission() {
//fade out
const landingRef = useRef(null);
  const nextSectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
        if (landingRef.current && nextSectionRef.current) {
          const nextSectionRect = nextSectionRef.current.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const triggerPoint = viewportHeight * 0.3; // When next section top hits 70% viewport height
  
          if (nextSectionRect.top <= triggerPoint) {
            // Progress from 0 to 1 based on how far past the trigger point we've scrolled
            // Sensitivity: Higher divisor = slower fade (e.g., nextSectionRect.height * 1)
            // Sensitivity: Lower divisor = faster fade (e.g., nextSectionRect.height * 0.3)
            const progress = Math.min(1, Math.max(0, (triggerPoint - nextSectionRect.top) / (nextSectionRect.height * 0.5)));
            setScrollProgress(progress);
          } else {
            // Reset progress if above the trigger point
            setScrollProgress(0);
          }
        }
      };
  
      // Run calculation once on mount in case initial position triggers it
      handleScroll();
  
      window.addEventListener('scroll', handleScroll, { passive: true }); // Added passive option
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []); // Empty dependency array means this runs once on mount
  
    // --- Calculate Brightness instead of Opacity ---
    // Brightness goes from 1 (normal) down to 0 (black)
    // Multiplier >= 1 controls fade speed (e.g., * 1.5 fades faster than progress)
    const brightnessValue = Math.max(0, 1 - scrollProgress * 1.5);
  
    // Calculate blur (increasing as scrollProgress increases)
    // Multiplier controls blur intensity relative to progress
    const blurAmount = Math.min(1, scrollProgress * 5) * 15; // Max blur 15px
    //fade in
    const missionRef = useRef(null);
    const [isAtTop, setIsAtTop] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        if (missionRef.current) {
          const rect = missionRef.current.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const fadeOutStartThreshold = viewportHeight * 0.10; // 20% of viewport height
  
          // Check if the top of the div has scrolled past the point where the fade should start
          setIsAtTop(rect.top <= fadeOutStartThreshold);
        }
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  
    return (
      <div className="width">
        <div className="missionMain">
          <div
            ref={missionRef}
            className={`missionTransitionImage ${isAtTop ? 'at-top' : ''}`}
          >
            <div className="medwidth">
            <div className="missionBigTextContainer">
             <div className="bigText">
                NO
            </div>
            <div className="bigText">
                JOB
            </div>
            <div className="bigText">
                IS
            </div>
            <div className="bigText">
               WORTH
            </div>
            <div className="bigText">
                YOUR
            </div>
            <div className="bigText2">
            <SlotMachineRotator
          words={["HEALTH","SAFETY","LIMBS","LIFE"]}
          className="text-rotator-highlight" // Optional: for styling
          style={{ fontWeight: 'bold' }} // Optional: for styling
          scrollSensitivity={6}
          stickToEnd={true}
        />
        </div>
            </div>
            <img src={site} className="missionImage" alt="the threehalves robot at a forestry site holding a chainsaw"></img>
          </div>
          </div>
          <div className="missionMiddle">
            <div className="missionBodyText">
            That doesn’t mean a job isn’t worth doing. We spend much of our lives mastering our crafts, honing our skills, but our bodies limit us - it doesn't have to be this way. We are taking a teleoperation focused approach not to replace skilled workers, but give skilled workers superpowers - in jobs that are dangerous for humans now, or impossible, due to risk of injury or death, extreme heat, bitter cold, pitch darkness, or other inhumane conditions.
            </div>
          </div>
          {/* <div 
          ref={landingRef}
          className="landing2"
          style={{
            filter: `blur(${blurAmount}px) brightness(${brightnessValue})`,
          }}
          > */}
          <div className="medwidth">
          <div className="designImageContainer"
                    ref={landingRef}
                    style={{
                        filter: `blur(${blurAmount}px) brightness(${brightnessValue})`,
                      }}
                    >
          <div className="teleopText">BECOME SUPERHUMAN</div>
          <img src={teleopClose} className="designImage2" alt="a laptop in a toolcase with a joystick showing the control UI for the threehalves robot">
          </img>
          </div>
            </div>
        </div>
        <div ref={nextSectionRef} className="next-section">
      </div>
      </div>
    );
  }
  
  export default Mission;